import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { actionCreators } from '../../store/modules/Email';
import Image from '../../controls/ImageUpload';
import date from '../../utils/date';
import SaveButton from '../../controls/SaveButton';
import DeleteButton from '../../controls/DeleteButton';
import BackButton from '../../controls/BackButton';

class EmailEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id === 'new' ? null : Number(props.match.params.id),
    };
    this.form = React.createRef();
  }

  componentWillMount() {
    const { id } = this.state;
    const { requestGet } = this.props;

    if (id) {
      requestGet(id);
    }
  }

  handleSave(values) {
    const { id } = this.state;
    const { requestPost } = this.props;

    if (!id) {
      requestPost(JSON.stringify(values));
    }
  }

  testRecipients() {
    const { recipients } = this.parent;
    if (recipients) {
      const ids = recipients.split(/,;| /).filter(x => !!x);
      if (ids.length < 500) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { email, requestDelete } = this.props;
    const { id } = this.state;

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          subject: Yup.string()
            .max(78)
            .required(),
          body: Yup.string().required(),
          recipients: Yup.string()
            .required()
            .test('valid-recipients', 'Nepareizi saņēmēji', this.testRecipients),
          imageId: Yup.string().nullable(),
        })}
        initialValues={
          id && email && email.id === id
            ? email
            : {
              recipients: '',
              subject: '',
              body: '',
              imageId: '',
            }
        }
        render={({ values, errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-md-12">
                  <span className="page-title hex-img">{id ? 'E-pasts' : 'Jauns E-pasts'}</span>
                  <div className="pageStyle">
                    <BackButton />
                    {id && <DeleteButton onClick={() => requestDelete(id)} />}
                    {!id && <SaveButton />}
                  </div>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default hex">
                    <div className="octomask">
                      <div className="octomask1" />
                    </div>
                    <div className="octo">
                      <div className="octo1">
                        <Image imageIds={[values.imageId]} form={this.form}
                          single readOnly={!!id} />
                      </div>
                    </div>
                    <div className="panel-heading" />
                    <div className="panel-body hex" id="scroller">
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="recipients" className="control-label font-bold">
                                Saņēmēji
                                <Field id="recipients"
                                  name="recipients"
                                  component="textarea"
                                  autoFocus
                                  rows="3"
                                  className={errors.recipients ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="subject" className="control-label font-bold">
                                Temats
                                <Field id="subject"
                                  name="subject"
                                  className={errors.subject ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="body" className="control-label font-bold">
                                Teksts
                                <Field id="body"
                                  name="body"
                                  component="textarea"
                                  rows="5"
                                  className={errors.body ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {id
                        && email && (
                          <div className="col-sm-3 form-additional-info">
                            <label>
                              Izveidots
                              <div>{date.long(email.createdOn)}</div>
                            </label>
                          </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

EmailEdit.propTypes = {
  email: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  requestGet: PropTypes.func.isRequired,
  requestPost: PropTypes.func.isRequired,
  requestDelete: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
};

EmailEdit.defaultProps = {
  email: null,
};

export default connect(
  state => ({
    email: state.email.current,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(EmailEdit);



// WEBPACK FOOTER //
// ./src/components/email/Edit.jsx